export default __webpack_public_path__ + "static/media/icon-001.e5353258.svg";